<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Centros de Custo</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/financas">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Visualize e gerencie seus centros de custo.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="bulkExcluir()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir</span>
                    </button>
                    <button mat-menu-item (click)="bulkInativar()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">block</mat-icon>
                        <span>Inativar</span>
                    </button>
                </mat-menu>
                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/financas/centros-custo/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Novo Centro de Custo
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar...</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque pelo nome ou código do centro de custo...">
                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <!-- select column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"></mat-checkbox>
                </td>
            </ng-container>
            <!-- codigo column -->
            <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.codigo || '—' }}
                </td>
            </ng-container>
            <!-- nome column -->
            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
                <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
            </ng-container>
            <!-- status column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="element.isAtivo ? 'badge-verde' : 'badge-cinza'">
                        {{ element.isAtivo ? 'Ativo' : 'Inativo' }}
                    </span>
                </td>
            </ng-container>
            <!-- actions column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/centros-custo/cadastrar', {idCentroCusto: element.idCentroCusto}]">
                            <span class="material-symbols-outlined">edit</span><span>Editar</span>
                        </button>
                        @if(element.isAtivo) {
                        <button mat-menu-item (click)="inativarItem(element)">
                            <span class="material-symbols-outlined">toggle_off</span><span>Inativar</span>
                        </button>
                        }
                        <button mat-menu-item (click)="abrirModalExcluir(element)">
                            <span class="material-symbols-outlined">delete</span><span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Mobile view -->
        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idCentroCusto) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary"></mat-checkbox>
                        <span class="text-bold">{{ item.nome }}</span>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/centros-custo/cadastrar', {idCentroCusto: item.idCentroCusto}]">
                            Editar
                        </button>
                        @if(item.isAtivo) {
                        <button mat-menu-item (click)="inativarItem(item)">Inativar</button>
                        }
                        <button mat-menu-item (click)="abrirModalExcluir(item)">Excluir</button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile">
                    @if(item.codigo) {
                    <div class="card-row-mobile">
                        <span>Código</span>
                        <span>{{ item.codigo }}</span>
                    </div>
                    }
                    <div class="card-row-mobile">
                        <span>Status</span>
                        <span class="status-badge" [ngClass]="item.isAtivo ? 'badge-verde' : 'badge-cinza'">
                            {{ item.isAtivo ? 'Ativo' : 'Inativo' }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais"
                [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span> Ver Mais
                }
            </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhum centro de custo encontrado'"
            [subTitle]="'Adicione um novo centro de custo para começar'"></app-empty-list>
        }
    </div>
</div>